/*
 * Copyright (c) 2016-2017 VMware, Inc. All Rights Reserved.
 * This software is released under MIT license.
 * The full license information can be found in LICENSE in the root directory of this project.
 */
import { Directive, TemplateRef } from "@angular/core";
var WizardPageButtonsDirective = (function () {
    function WizardPageButtonsDirective(pageButtonsTemplateRef) {
        this.pageButtonsTemplateRef = pageButtonsTemplateRef;
    }
    return WizardPageButtonsDirective;
}());
export { WizardPageButtonsDirective };
WizardPageButtonsDirective.decorators = [
    { type: Directive, args: [{
                selector: "[clrPageButtons]"
            },] },
];
/** @nocollapse */
WizardPageButtonsDirective.ctorParameters = function () { return [
    { type: TemplateRef, },
]; };
//# sourceMappingURL=page-buttons.js.map


//////////////////
// WEBPACK FOOTER
// ./~/clarity-angular/wizard/directives/page-buttons.js
// module id = 97
// module chunks = 4